import React, { useState, useEffect } from 'react';
import Style from '../New/Style.module.css'; // Importing styles from New folder
import Header from '../../../Components/AdminComponents/Header/Header';
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar';
import { toast } from 'react-toastify';
import adminInstance from '../../../instance/AdminInstance';

const AdminAppUpdate = () => {
    const [versions, setVersions] = useState([]);
    const [input, setInput] = useState({
        platform: 'android',
        version: '',
        storeUrl: '',
        description: '',
        forceUpdate: false,
        buildNumber: ''
    });

    useEffect(() => {
        fetchVersions();
    }, []);

    const fetchVersions = async () => {
        try {
            const res = await adminInstance.get('/api/app_version/all');
            setVersions(res.data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch versions");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await adminInstance.post('/api/app_version/create', input);
            toast.success("Version released successfully");
            setInput({
                platform: 'android',
                version: '',
                storeUrl: '',
                description: '',
                forceUpdate: false,
                buildNumber: ''
            });
            fetchVersions();
        } catch (error) {
            console.error(error);
            toast.error("Failed to release version");
        }
    };

    return (
        <div className={Style.new}>
            <Sidebar />
            <div className={Style.newContainer}>
                <Header />
                <div className={Style.top}>
                    <h1>App Updates Management</h1>
                </div>

                <div className={Style.center}>
                    <div className={Style.right}>
                        <form onSubmit={handleSubmit}>
                            <div className={Style.formInput}>
                                <label>Platform</label>
                                <select
                                    value={input.platform}
                                    onChange={(e) => setInput({ ...input, platform: e.target.value })}
                                >
                                    <option value="android">Android</option>
                                    <option value="ios">iOS</option>
                                </select>
                            </div>

                            <div className={Style.formInput}>
                                <label>Version (e.g., 1.0.1)</label>
                                <input
                                    type="text"
                                    placeholder="1.0.0"
                                    value={input.version}
                                    onChange={(e) => setInput({ ...input, version: e.target.value })}
                                    required
                                />
                            </div>

                            <div className={Style.formInput}>
                                <label>Store URL</label>
                                <input
                                    type="text"
                                    placeholder="https://play.google.com/..."
                                    value={input.storeUrl}
                                    onChange={(e) => setInput({ ...input, storeUrl: e.target.value })}
                                    required
                                />
                            </div>

                            <div className={Style.formInput}>
                                <label>Description</label>
                                <input
                                    type="text"
                                    placeholder="What's new?"
                                    value={input.description}
                                    onChange={(e) => setInput({ ...input, description: e.target.value })}
                                />
                            </div>

                            <div className={Style.formInput}>
                                <label>Force Update</label>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input
                                        type="checkbox"
                                        checked={input.forceUpdate}
                                        onChange={(e) => setInput({ ...input, forceUpdate: e.target.checked })}
                                        style={{ width: '20px', height: '20px' }}
                                    />
                                    <span>Make this update mandatory</span>
                                </div>
                            </div>

                            <div className={Style.formBtn}>
                                <button type="submit">Release Version</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className={Style.bottomTable}>
                    <h1 className={Style.title}>Version History</h1>
                    <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', padding: '10px' }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #ddd' }}>
                                <th style={{ padding: '10px' }}>Platform</th>
                                <th style={{ padding: '10px' }}>Version</th>
                                <th style={{ padding: '10px' }}>Force Update</th>
                                <th style={{ padding: '10px' }}>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versions.map((v) => (
                                <tr key={v._id} style={{ borderBottom: '1px solid #eee' }}>
                                    <td style={{ padding: '10px' }}>{v.platform}</td>
                                    <td style={{ padding: '10px' }}>{v.version}</td>
                                    <td style={{ padding: '10px' }}>{v.forceUpdate ? 'Yes' : 'No'}</td>
                                    <td style={{ padding: '10px' }}>{new Date(v.createdAt).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AdminAppUpdate;
